<template>
    <!--
        Chatbox component.
        Displays a tools overlay
        Closable by clicking button close (x) or by finishing the process
    -->
    <div :class="['tools', typing && touchDevice? 'is-typing' : '']" @keydown.esc="close()">
        <div class="posts" ref="posts">
            <div class="posts-inner">
                <div class="post" v-for="post in getComments(date)">
                    <div class="details">
                        <span>{{ post.user.name }}</span>
                        <time :datetime="post.createdAt">{{ post.localized }}</time>
                    </div>
                    <div>
                        <p>{{ post.message }}</p>
                    </div>
                    <icon v-if="canDelete(post.user)" name="delete" @click.native.prevent="deleteComment(post.id)" />
                </div>
            </div>
        </div>
        <div class="input">
            <textarea :placeholder="placeholder" ref="message" v-model.trim="message" @focus="setFocus" @blur="setBlur"></textarea>

            <action color="grey" @click.native.prevent="$refs.message.blur()" class="cancel" v-if="typing && touchDevice">{{ $t('common.button.cancel') }}</action>
            <action color="grey" @click.native.prevent="close" class="close">{{ $t('common.button.close') }}</action>
            <action color="green" @click.native.prevent="submitMessage(date)" class="submit">{{ $t('common.button.add') }}</action>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {mapState} from 'vuex';
import events from '../../events/events';
import shared from '../../pages/planning/shared';

export default
{
    name: 'Chatbox',

    props: ['payload'],

    data() {
        return {
            shared: shared.state,
            initialized: false,
            message: '',

            typing: false,
        }
    },

    mounted()
    {
        this.init();
    },

    computed:
    {
        ...mapState({
            touchDevice: ({ app }) => app.touchDevice
        }),

        placeholder()
        {
            return this.$t('page.roster.placeholder.comment');
        },

        date()
        {
            return this.payload;
        },
    },

    watch:
    {
        payload()
        {
            this.init();
        },
    },

    methods:
    {
        init: function()
        {
            this.message = '';
            this.scrollToBottom();
            this.initialized = true;
        },

        scrollToBottom()
        {
            this.$nextTick(() =>
            {
                this.$refs.posts.scrollTop = this.$refs.posts.scrollHeight;

                this.$nextTick(() =>
                {
                    this.$refs.message.focus();
                });
            });
        },

        getComments()
        {
            return shared.getComments(this.payload);
        },

        deleteComment(id)
        {
            this.$http.delete('/api/messages/' + id)
            .then(response =>
            {
                shared.removeComment(id);
                this.scrollToBottom();
            });
        },

        canDelete(user)
        {
            return this.$store.state.current.user.id === user.id || this.$onduro.hasRole(['owner', 'manager']);
        },

        submitMessage(date)
        {
            if ( ! this.message) return;

            this.$http.post('/api/messages', {
                'location': this.shared.location,
                'date': date,
                'comment': this.message,
            })
            .then(response =>
            {
                this.message = '';
                this.shared.comments.push(response.data);
                this.scrollToBottom();
            });
        },

        close()
        {
            events.$emit('toolbox.close');
        },

        setFocus()
        {
            events.$emit('input.focus', true);
            this.typing = true;
        },

        setBlur()
        {
//            events.$emit('input.focus', false);
            this.typing = false;
        }
    },
}
</script>



// WEBPACK FOOTER //
// Chatbox.vue?a54cf862